<template>
  <FormSelect :field="field" v-if="lang == 'he'" :disabled="readonly">
    <option :value="null"></option>
    <option v-for="[short, long] of countriesHe" :key="short" :value="short">
      {{ long }}
    </option>
  </FormSelect>
  <FormSelect :field="field" v-else-if="lang == 'he-all'" :disabled="readonly">
    <option :value="null"></option>
    <option v-for="[short, long] of countriesHeAll" :key="short" :value="short">
      {{ long }}
    </option>
  </FormSelect>
  <FormSelect :field="field" v-else-if="lang == 'is'" :disabled="readonly">
    <option :value="null"></option>
    <option v-for="[short, long] of countriesIs" :key="short" :value="short">
      {{ long }}
    </option>
  </FormSelect>
  <FormSelect :field="field" v-else-if="lang == 'canada'" :disabled="readonly">
    <option :value="null"></option>
    <option v-for="[short, long] of countriesCad" :key="short" :value="short">
      {{ long }}
    </option>
  </FormSelect>
  <FormSelect :field="field" :disabled="readonly" v-else>
    <option :value="null"></option>
    <option v-for="[short, long] of countries" :key="short" :value="short">
      {{ long }}
    </option>
  </FormSelect>
</template>
<script setup lang="ts">
import { inject } from "vue";

const countriesHeAll = [
  ["US", "ארצות הברית"],
  ["CA", "קנדה"],
  ["IL", "ישראל"],
  ["GB", "בריטניה"],
  ["AU", "אוסטרליה"],
  ["ZA", "דרום אפריקה"],
  ["AF", "אפגניסטן"],
  ["AX", "איי אולנד"],
  ["AL", "אלבניה"],
  ["DZ", "אלג'יריה"],
  ["AS", "סמואה אמריקאית"],
  ["AD", "אנדורה"],
  ["AO", "אנגולה"],
  ["AI", "צלופח"],
  ["AQ", "אנטארקטיקה"],
  ["AG", "אנטיגואה וברבודה"],
  ["AR", "ארגנטינה"],
  ["AM", "ארמניה"],
  ["AW", "ארובה"],
  ["AT", "אוסטריה"],
  ["AZ", "אזרבייג'ן"],
  ["BS", "בהאמה"],
  ["BH", "בחריין"],
  ["BD", "בנגלדש"],
  ["BB", "ברבדוס"],
  ["BY", "בלארוס"],
  ["BE", "בלגיה"],
  ["BZ", "בליז"],
  ["BJ", "בנין"],
  ["BM", "ברמודה"],
  ["BT", "בהוטן"],
  ["BO", "בוליביה"],
  ["BA", "בוסניה והרצגובינה"],
  ["BW", "בוטסואנה"],
  ["BV", "Bouvet Island"],
  ["BR", "ברזיל"],
  ["IO", "טריטוריית האוקיינוס ​​ההודי הבריטי"],
  ["BN", "ברוניי דרוסלם"],
  ["BG", "בולגריה"],
  ["BF", "בורקינה פאסו"],
  ["BI", "בורונדי"],
  ["KH", "קמבודיה"],
  ["CM", "קמרון"],
  ["CV", "קייפ ורדה"],
  ["KY", "איי קיימן"],
  ["CF", "הרפובליקה המרכז אפריקאית"],
  ["TD", "צ'אד"],
  ["CL", "צ'ילה"],
  ["CN", "סין"],
  ["CX", "אי חג המולד"],
  ["CC", "איי קוקוס"],
  ["CO", "קולומביה"],
  ["KM", "Comoros"],
  ["CG", "קונגו"],
  ["CD", "קונגו, הרפובליקה הדמוקרטית של ה"],
  ["CK", "איי קוק"],
  ["CR", "קוסטה ריקה"],
  ["CI", "Cote D'Ivoire"],
  ["HR", "קרואטיה"],
  ["CU", "קובה"],
  ["CY", "קפריסין"],
  ["CZ", "צ'כיה"],
  ["DK", "דנמרק"],
  ["DJ", "ג'יבוטי"],
  ["DM", "Dominica"],
  ["DO", "הרפובליקה הדומיניקנית"],
  ["EC", "אקוודור"],
  ["EG", "מצרים"],
  ["SV", "המושיע"],
  ["GQ", "גינאה המשוונית"],
  ["ER", "אריתריאה"],
  ["AS", "אסטוניה"],
  ["ET", "אתיופיה"],
  ["FK", "איי פוקלנד (פוקלנד)"],
  ["FO", "איי פארו"],
  ["FJ", "פיג'י"],
  ["FI", "פינלנד"],
  ["FR", "צרפת"],
  ["GF", "גיאנה הצרפתית"],
  ["PF", "פולינזיה הצרפתית"],
  ["TF", "טריטוריות דרום צרפתיות"],
  ["GA", "גבון"],
  ["GM", "גמביה"],
  ["GE", "ג'ורג'יה"],
  ["DE", "גרמניה"],
  ["GH", "Ghana"],
  ["GI", "גיברלטר"],
  ["GR", "יוון"],
  ["GL", "גרינלנד"],
  ["GD", "רימון"],
  ["GP", "גוואדלופ"],
  ["GU", "גואם"],
  ["GT", "גואטמלה"],
  ["GG", "גרנזי"],
  ["GN", "גינאה"],
  ["GW", "גינאה-ביסאו"],
  ["GY", "גוייניה"],
  ["HT", "האיטי"],
  ["HM", "איי הרד ואיי מקדונלד"],
  ["VA", "כס הקודש"],
  ["HN", "הונדורס"],
  ["HK", "הונג קונג"],
  ["HU", "הונגריה"],
  ["IS", "איסלנד"],
  ["IN", "הודו"],
  ["ID", "אינדונזיה"],
  ["IR", "איראן, הרפובליקה האסלאמית של"],
  ["IQ", "עיראק"],
  ["IE", "אירלנד"],
  ["IM", "אי מאן"],
  ["IT", "איטליה"],
  ["JM", "ג'מייקה"],
  ["JP", "יפן"],
  ["JE", "ג'רזי"],
  ["JO", "ירדן"],
  ["KZ", "קזחסטן"],
  ["KE", "קנייה"],
  ["KI", "קיריבטי"],
  ["KP", "הרפובליקה העממית הדמוקרטית של קוריאה"],
  ["KR", "קוריאה, הרפובליקה של"],
  ["XK", "קוסובו"],
  ["KW", "כווית"],
  ["KG", "קירגיזסטן"],
  ["LA", "הרפובליקה העממית הדמוקרטית של לאו"],
  ["LV", "לטביה"],
  ["לב", "לבנון"],
  ["LS", "לסוטו"],
  ["LR", "ליבריה"],
  ["LY", "ג'מהירייה ערבית לוב"],
  ["LI", "ליכטנשטיין"],
  ["LT", "ליטא"],
  ["LU", "לוקסמבורג"],
  ["MO", "מקאו"],
  ["MK", "מקדוניה, הרפובליקה היוגוסלבית לשעבר של"],
  ["MG", "מדגסקר"],
  ["MW", "מלאווי"],
  ["MY", "מלזיה"],
  ["MV", "המלדיביים"],
  ["ML", "מאלי"],
  ["MT", "מלטה"],
  ["MH", "איי מרשל"],
  ["MQ", "מרטיניק"],
  ["MR", "מאוריטניה"],
  ["MU", "מאוריציוס"],
  ["YT", "מיוט"],
  ["MX", "מקסיקו"],
  ["FM", "מיקרונזיה, מדינות הפדרציה של"],
  ["MD", "מולדובה, הרפובליקה של"],
  ["MC", "מונקו"],
  ["MN", "מונגוליה"],
  ["ME", "מונטנגרו"],
  ["MS", "מונטסרט"],
  ["MA", "מרוקו"],
  ["MZ", "מוזמביק"],
  ["MM", "מיאנמר"],
  ["NA", "נמיביה"],
  ["NR", "נאורו"],
  ["NP", "נפאל"],
  ["NL", "הולנד"],
  ["AN", "הודו המערבית הולנדית"],
  ["NC", "קלדוניה החדשה"],
  ["NZ", "ניו זילנד"],
  ["NI", "ניקרגואה"],
  ["NE", "ניג'ר"],
  ["NG", "ניגריה"],
  ["NU", "ניווה"],
  ["NF", "אי נורפוק"],
  ["MP", "איי מריאנה הצפוניים"],
  ["NO", "נורווגיה"],
  ["OM", "אומן"],
  ["PK", "פקיסטן"],
  ["PW", "פאלאו"],
  ["PA", "פנמה"],
  ["PG", "פפואה גינאה החדשה"],
  ["PY", "פרגוואי"],
  ["PE", "פרו"],
  ["PH", "פיליפינים"],
  ["PN", "פיטקרן"],
  ["PL", "פולין"],
  ["PT", "פורטוגל"],
  ["PR", "פוארטו ריקו"],
  ["QA", "קטאר"],
  ["RE", "ראוניון"],
  ["RO", "רומניה"],
  ["RU", "הפדרציה הרוסית"],
  ["RW", "רואנדה"],
  ["ש", "הלנה הקדושה"],
  ["KN", "סיינט קייטס"],
  ["LC", "סנט לוסיה"],
  ["PM", "סיינט פיטר"],
  ["VC", "סנט וינסנט והגרנדינים"],
  ["WS", "סמואה"],
  ["SM", "סן מרינו"],
  ["ST", "סאו טומה ופרינסיפה"],
  ["SA", "ערב הסעודית"],
  ["SN", "סנגל"],
  ["RS", "סרביה"],
  ["SC", "איי סיישל"],
  ["SL", "סיירה לאונה"],
  ["SG", "סינגפור"],
  ["SK", "סלובקיה"],
  ["SI", "סלובניה"],
  ["SB", "איי שלמה"],
  ["SO", "סומליה"],
  ["GS", "דרום ג'ורג'יה ואיי סנדוויץ' הדרומיים"],
  ["ES", "ספרד"],
  ["LK", "סרי לנקה"],
  ["SD", "סודן"],
  ["SR", "סורינאם"],
  ["SJ", "סוולברד"],
  ["SZ", "סווזילנד"],
  ["SE", "שבדיה"],
  ["CH", "שוויץ"],
  ["SY", "הרפובליקה הערבית הסורית"],
  ["TW", "טייוואן"],
  ["TJ", "טג'יקיסטן"],
  ["TZ", "טנזניה, הרפובליקה המאוחדת של"],
  ["TH", "תאילנד"],
  ["TL", "טימור-לסטה"],
  ["TG", "טוגו"],
  ["TK", "טוקלאו"],
  ["TO", "טונגה"],
  ["TT", "טרינידד וטובגו"],
  ["TN", "תוניסיה"],
  ["TR", "טורקיה"],
  ["TM", "טורקמניסטן"],
  ["TC", "איי טורקס וקייקוס"],
  ["TV", "טובאלו"],
  ["UG", "אוגנדה"],
  ["UA", "אוקראינה"],
  ["AE", "איחוד האמירויות הערביות"],
  ["UM", "איים מרוחקים של ארצות הברית"],
  ["UY", "אורוגוואי"],
  ["UZ", "אוזבקיסטן"],
  ["VU", "Vanuatu"],
  ["VE", "ונצואלה"],
  ["VN", "וייטנאם"],
  ["VG", "איי הבתולה, בריטים"],
  ["VI", "איי הבתולה"],
  ["WF", "וואליס ופוטונה"],
  ["EH", "סהרה המערבית"],
  ["YE", "תימן"],
  ["ZM", "זמביה"],
  ["ZW", "Zimbabwe"],
];

const countriesHe = [
  ["US", "ארצות הברית"],
  ["CA", "קנדה"],
  ["IL", "ישראל"],
];
const countriesIs = [["IL", "ישראל"]];
const countries = [
  ["US", "United States"],
  ["CA", "Canada"],
  ["IL", "Israel"],
  ["GB", "United Kingdom"],
  ["AU", "Australia"],
  ["ZA", "South Africa"],
  ["AF", "Afghanistan"],
  ["AX", "Åland Islands"],
  ["AL", "Albania"],
  ["DZ", "Algeria"],
  ["AS", "American Samoa"],
  ["AD", "Andorra"],
  ["AO", "Angola"],
  ["AI", "Anguilla"],
  ["AQ", "Antarctica"],
  ["AG", "Antigua and Barbuda"],
  ["AR", "Argentina"],
  ["AM", "Armenia"],
  ["AW", "Aruba"],
  ["AT", "Austria"],
  ["AZ", "Azerbaijan"],
  ["BS", "Bahamas"],
  ["BH", "Bahrain"],
  ["BD", "Bangladesh"],
  ["BB", "Barbados"],
  ["BY", "Belarus"],
  ["BE", "Belgium"],
  ["BZ", "Belize"],
  ["BJ", "Benin"],
  ["BM", "Bermuda"],
  ["BT", "Bhutan"],
  ["BO", "Bolivia"],
  ["BA", "Bosnia and Herzegovina"],
  ["BW", "Botswana"],
  ["BV", "Bouvet Island"],
  ["BR", "Brazil"],
  ["IO", "British Indian Ocean Territory"],
  ["BN", "Brunei Darussalam"],
  ["BG", "Bulgaria"],
  ["BF", "Burkina Faso"],
  ["BI", "Burundi"],
  ["KH", "Cambodia"],
  ["CM", "Cameroon"],
  ["CV", "Cape Verde"],
  ["KY", "Cayman Islands"],
  ["CF", "Central African Republic"],
  ["TD", "Chad"],
  ["CL", "Chile"],
  ["CN", "China"],
  ["CX", "Christmas Island"],
  ["CC", "Cocos (Keeling) Islands"],
  ["CO", "Colombia"],
  ["KM", "Comoros"],
  ["CG", "Congo"],
  ["CD", "Congo, The Democratic Republic of the"],
  ["CK", "Cook Islands"],
  ["CR", "Costa Rica"],
  ["CI", "Cote D'Ivoire"],
  ["HR", "Croatia"],
  ["CU", "Cuba"],
  ["CY", "Cyprus"],
  ["CZ", "Czech Republic"],
  ["DK", "Denmark"],
  ["DJ", "Djibouti"],
  ["DM", "Dominica"],
  ["DO", "Dominican Republic"],
  ["EC", "Ecuador"],
  ["EG", "Egypt"],
  ["SV", "El Salvador"],
  ["GQ", "Equatorial Guinea"],
  ["ER", "Eritrea"],
  ["EE", "Estonia"],
  ["ET", "Ethiopia"],
  ["FK", "Falkland Islands (Malvinas)"],
  ["FO", "Faroe Islands"],
  ["FJ", "Fiji"],
  ["FI", "Finland"],
  ["FR", "France"],
  ["GF", "French Guiana"],
  ["PF", "French Polynesia"],
  ["TF", "French Southern Territories"],
  ["GA", "Gabon"],
  ["GM", "Gambia"],
  ["GE", "Georgia"],
  ["DE", "Germany"],
  ["GH", "Ghana"],
  ["GI", "Gibraltar"],
  ["GR", "Greece"],
  ["GL", "Greenland"],
  ["GD", "Grenada"],
  ["GP", "Guadeloupe"],
  ["GU", "Guam"],
  ["GT", "Guatemala"],
  ["GG", "Guernsey"],
  ["GN", "Guinea"],
  ["GW", "Guinea-Bissau"],
  ["GY", "Guyana"],
  ["HT", "Haiti"],
  ["HM", "Heard Island and Mcdonald Islands"],
  ["VA", "Holy See (Vatican City State)"],
  ["HN", "Honduras"],
  ["HK", "Hong Kong"],
  ["HU", "Hungary"],
  ["IS", "Iceland"],
  ["IN", "India"],
  ["ID", "Indonesia"],
  ["IR", "Iran, Islamic Republic Of"],
  ["IQ", "Iraq"],
  ["IE", "Ireland"],
  ["IM", "Isle of Man"],
  ["IT", "Italy"],
  ["JM", "Jamaica"],
  ["JP", "Japan"],
  ["JE", "Jersey"],
  ["JO", "Jordan"],
  ["KZ", "Kazakhstan"],
  ["KE", "Kenya"],
  ["KI", "Kiribati"],
  ["KP", "Democratic People's Republic of Korea"],
  ["KR", "Korea, Republic of"],
  ["XK", "Kosovo"],
  ["KW", "Kuwait"],
  ["KG", "Kyrgyzstan"],
  ["LA", "Lao People's Democratic Republic"],
  ["LV", "Latvia"],
  ["LB", "Lebanon"],
  ["LS", "Lesotho"],
  ["LR", "Liberia"],
  ["LY", "Libyan Arab Jamahiriya"],
  ["LI", "Liechtenstein"],
  ["LT", "Lithuania"],
  ["LU", "Luxembourg"],
  ["MO", "Macao"],
  ["MK", "Macedonia, The Former Yugoslav Republic of"],
  ["MG", "Madagascar"],
  ["MW", "Malawi"],
  ["MY", "Malaysia"],
  ["MV", "Maldives"],
  ["ML", "Mali"],
  ["MT", "Malta"],
  ["MH", "Marshall Islands"],
  ["MQ", "Martinique"],
  ["MR", "Mauritania"],
  ["MU", "Mauritius"],
  ["YT", "Mayotte"],
  ["MX", "Mexico"],
  ["FM", "Micronesia, Federated States of"],
  ["MD", "Moldova, Republic of"],
  ["MC", "Monaco"],
  ["MN", "Mongolia"],
  ["ME", "Montenegro"],
  ["MS", "Montserrat"],
  ["MA", "Morocco"],
  ["MZ", "Mozambique"],
  ["MM", "Myanmar"],
  ["NA", "Namibia"],
  ["NR", "Nauru"],
  ["NP", "Nepal"],
  ["NL", "Netherlands"],
  ["AN", "Netherlands Antilles"],
  ["NC", "New Caledonia"],
  ["NZ", "New Zealand"],
  ["NI", "Nicaragua"],
  ["NE", "Niger"],
  ["NG", "Nigeria"],
  ["NU", "Niue"],
  ["NF", "Norfolk Island"],
  ["MP", "Northern Mariana Islands"],
  ["NO", "Norway"],
  ["OM", "Oman"],
  ["PK", "Pakistan"],
  ["PW", "Palau"],
  ["PA", "Panama"],
  ["PG", "Papua New Guinea"],
  ["PY", "Paraguay"],
  ["PE", "Peru"],
  ["PH", "Philippines"],
  ["PN", "Pitcairn"],
  ["PL", "Poland"],
  ["PT", "Portugal"],
  ["PR", "Puerto Rico"],
  ["QA", "Qatar"],
  ["RE", "Reunion"],
  ["RO", "Romania"],
  ["RU", "Russian Federation"],
  ["RW", "Rwanda"],
  ["SH", "Saint Helena"],
  ["KN", "Saint Kitts and Nevis"],
  ["LC", "Saint Lucia"],
  ["PM", "Saint Pierre and Miquelon"],
  ["VC", "Saint Vincent and the Grenadines"],
  ["WS", "Samoa"],
  ["SM", "San Marino"],
  ["ST", "Sao Tome and Principe"],
  ["SA", "Saudi Arabia"],
  ["SN", "Senegal"],
  ["RS", "Serbia"],
  ["SC", "Seychelles"],
  ["SL", "Sierra Leone"],
  ["SG", "Singapore"],
  ["SK", "Slovakia"],
  ["SI", "Slovenia"],
  ["SB", "Solomon Islands"],
  ["SO", "Somalia"],
  ["GS", "South Georgia and the South Sandwich Islands"],
  ["ES", "Spain"],
  ["LK", "Sri Lanka"],
  ["SD", "Sudan"],
  ["SR", "Suriname"],
  ["SJ", "Svalbard and Jan Mayen"],
  ["SZ", "Swaziland"],
  ["SE", "Sweden"],
  ["CH", "Switzerland"],
  ["SY", "Syrian Arab Republic"],
  ["TW", "Taiwan"],
  ["TJ", "Tajikistan"],
  ["TZ", "Tanzania, United Republic of"],
  ["TH", "Thailand"],
  ["TL", "Timor-Leste"],
  ["TG", "Togo"],
  ["TK", "Tokelau"],
  ["TO", "Tonga"],
  ["TT", "Trinidad and Tobago"],
  ["TN", "Tunisia"],
  ["TR", "Turkey"],
  ["TM", "Turkmenistan"],
  ["TC", "Turks and Caicos Islands"],
  ["TV", "Tuvalu"],
  ["UG", "Uganda"],
  ["UA", "Ukraine"],
  ["AE", "United Arab Emirates"],
  ["UM", "United States Minor Outlying Islands"],
  ["UY", "Uruguay"],
  ["UZ", "Uzbekistan"],
  ["VU", "Vanuatu"],
  ["VE", "Venezuela"],
  ["VN", "Viet Nam"],
  ["VG", "Virgin Islands, British"],
  ["VI", "Virgin Islands, U.S."],
  ["WF", "Wallis and Futuna"],
  ["EH", "Western Sahara"],
  ["YE", "Yemen"],
  ["ZM", "Zambia"],
  ["ZW", "Zimbabwe"],
];
const countriesCad = [  
  ["CA", "Canada"],
  ["US", "United States"],
  ["IL", "Israel"],
  ["GB", "United Kingdom"],
  ["AU", "Australia"],
  ["ZA", "South Africa"],
  ["AF", "Afghanistan"],
  ["AX", "Åland Islands"],
  ["AL", "Albania"],
  ["DZ", "Algeria"],
  ["AS", "American Samoa"],
  ["AD", "Andorra"],
  ["AO", "Angola"],
  ["AI", "Anguilla"],
  ["AQ", "Antarctica"],
  ["AG", "Antigua and Barbuda"],
  ["AR", "Argentina"],
  ["AM", "Armenia"],
  ["AW", "Aruba"],
  ["AT", "Austria"],
  ["AZ", "Azerbaijan"],
  ["BS", "Bahamas"],
  ["BH", "Bahrain"],
  ["BD", "Bangladesh"],
  ["BB", "Barbados"],
  ["BY", "Belarus"],
  ["BE", "Belgium"],
  ["BZ", "Belize"],
  ["BJ", "Benin"],
  ["BM", "Bermuda"],
  ["BT", "Bhutan"],
  ["BO", "Bolivia"],
  ["BA", "Bosnia and Herzegovina"],
  ["BW", "Botswana"],
  ["BV", "Bouvet Island"],
  ["BR", "Brazil"],
  ["IO", "British Indian Ocean Territory"],
  ["BN", "Brunei Darussalam"],
  ["BG", "Bulgaria"],
  ["BF", "Burkina Faso"],
  ["BI", "Burundi"],
  ["KH", "Cambodia"],
  ["CM", "Cameroon"],
  ["CV", "Cape Verde"],
  ["KY", "Cayman Islands"],
  ["CF", "Central African Republic"],
  ["TD", "Chad"],
  ["CL", "Chile"],
  ["CN", "China"],
  ["CX", "Christmas Island"],
  ["CC", "Cocos (Keeling) Islands"],
  ["CO", "Colombia"],
  ["KM", "Comoros"],
  ["CG", "Congo"],
  ["CD", "Congo, The Democratic Republic of the"],
  ["CK", "Cook Islands"],
  ["CR", "Costa Rica"],
  ["CI", "Cote D'Ivoire"],
  ["HR", "Croatia"],
  ["CU", "Cuba"],
  ["CY", "Cyprus"],
  ["CZ", "Czech Republic"],
  ["DK", "Denmark"],
  ["DJ", "Djibouti"],
  ["DM", "Dominica"],
  ["DO", "Dominican Republic"],
  ["EC", "Ecuador"],
  ["EG", "Egypt"],
  ["SV", "El Salvador"],
  ["GQ", "Equatorial Guinea"],
  ["ER", "Eritrea"],
  ["EE", "Estonia"],
  ["ET", "Ethiopia"],
  ["FK", "Falkland Islands (Malvinas)"],
  ["FO", "Faroe Islands"],
  ["FJ", "Fiji"],
  ["FI", "Finland"],
  ["FR", "France"],
  ["GF", "French Guiana"],
  ["PF", "French Polynesia"],
  ["TF", "French Southern Territories"],
  ["GA", "Gabon"],
  ["GM", "Gambia"],
  ["GE", "Georgia"],
  ["DE", "Germany"],
  ["GH", "Ghana"],
  ["GI", "Gibraltar"],
  ["GR", "Greece"],
  ["GL", "Greenland"],
  ["GD", "Grenada"],
  ["GP", "Guadeloupe"],
  ["GU", "Guam"],
  ["GT", "Guatemala"],
  ["GG", "Guernsey"],
  ["GN", "Guinea"],
  ["GW", "Guinea-Bissau"],
  ["GY", "Guyana"],
  ["HT", "Haiti"],
  ["HM", "Heard Island and Mcdonald Islands"],
  ["VA", "Holy See (Vatican City State)"],
  ["HN", "Honduras"],
  ["HK", "Hong Kong"],
  ["HU", "Hungary"],
  ["IS", "Iceland"],
  ["IN", "India"],
  ["ID", "Indonesia"],
  ["IR", "Iran, Islamic Republic Of"],
  ["IQ", "Iraq"],
  ["IE", "Ireland"],
  ["IM", "Isle of Man"],
  ["IT", "Italy"],
  ["JM", "Jamaica"],
  ["JP", "Japan"],
  ["JE", "Jersey"],
  ["JO", "Jordan"],
  ["KZ", "Kazakhstan"],
  ["KE", "Kenya"],
  ["KI", "Kiribati"],
  ["KP", "Democratic People's Republic of Korea"],
  ["KR", "Korea, Republic of"],
  ["XK", "Kosovo"],
  ["KW", "Kuwait"],
  ["KG", "Kyrgyzstan"],
  ["LA", "Lao People's Democratic Republic"],
  ["LV", "Latvia"],
  ["LB", "Lebanon"],
  ["LS", "Lesotho"],
  ["LR", "Liberia"],
  ["LY", "Libyan Arab Jamahiriya"],
  ["LI", "Liechtenstein"],
  ["LT", "Lithuania"],
  ["LU", "Luxembourg"],
  ["MO", "Macao"],
  ["MK", "Macedonia, The Former Yugoslav Republic of"],
  ["MG", "Madagascar"],
  ["MW", "Malawi"],
  ["MY", "Malaysia"],
  ["MV", "Maldives"],
  ["ML", "Mali"],
  ["MT", "Malta"],
  ["MH", "Marshall Islands"],
  ["MQ", "Martinique"],
  ["MR", "Mauritania"],
  ["MU", "Mauritius"],
  ["YT", "Mayotte"],
  ["MX", "Mexico"],
  ["FM", "Micronesia, Federated States of"],
  ["MD", "Moldova, Republic of"],
  ["MC", "Monaco"],
  ["MN", "Mongolia"],
  ["ME", "Montenegro"],
  ["MS", "Montserrat"],
  ["MA", "Morocco"],
  ["MZ", "Mozambique"],
  ["MM", "Myanmar"],
  ["NA", "Namibia"],
  ["NR", "Nauru"],
  ["NP", "Nepal"],
  ["NL", "Netherlands"],
  ["AN", "Netherlands Antilles"],
  ["NC", "New Caledonia"],
  ["NZ", "New Zealand"],
  ["NI", "Nicaragua"],
  ["NE", "Niger"],
  ["NG", "Nigeria"],
  ["NU", "Niue"],
  ["NF", "Norfolk Island"],
  ["MP", "Northern Mariana Islands"],
  ["NO", "Norway"],
  ["OM", "Oman"],
  ["PK", "Pakistan"],
  ["PW", "Palau"],
  ["PA", "Panama"],
  ["PG", "Papua New Guinea"],
  ["PY", "Paraguay"],
  ["PE", "Peru"],
  ["PH", "Philippines"],
  ["PN", "Pitcairn"],
  ["PL", "Poland"],
  ["PT", "Portugal"],
  ["PR", "Puerto Rico"],
  ["QA", "Qatar"],
  ["RE", "Reunion"],
  ["RO", "Romania"],
  ["RU", "Russian Federation"],
  ["RW", "Rwanda"],
  ["SH", "Saint Helena"],
  ["KN", "Saint Kitts and Nevis"],
  ["LC", "Saint Lucia"],
  ["PM", "Saint Pierre and Miquelon"],
  ["VC", "Saint Vincent and the Grenadines"],
  ["WS", "Samoa"],
  ["SM", "San Marino"],
  ["ST", "Sao Tome and Principe"],
  ["SA", "Saudi Arabia"],
  ["SN", "Senegal"],
  ["RS", "Serbia"],
  ["SC", "Seychelles"],
  ["SL", "Sierra Leone"],
  ["SG", "Singapore"],
  ["SK", "Slovakia"],
  ["SI", "Slovenia"],
  ["SB", "Solomon Islands"],
  ["SO", "Somalia"],
  ["GS", "South Georgia and the South Sandwich Islands"],
  ["ES", "Spain"],
  ["LK", "Sri Lanka"],
  ["SD", "Sudan"],
  ["SR", "Suriname"],
  ["SJ", "Svalbard and Jan Mayen"],
  ["SZ", "Swaziland"],
  ["SE", "Sweden"],
  ["CH", "Switzerland"],
  ["SY", "Syrian Arab Republic"],
  ["TW", "Taiwan"],
  ["TJ", "Tajikistan"],
  ["TZ", "Tanzania, United Republic of"],
  ["TH", "Thailand"],
  ["TL", "Timor-Leste"],
  ["TG", "Togo"],
  ["TK", "Tokelau"],
  ["TO", "Tonga"],
  ["TT", "Trinidad and Tobago"],
  ["TN", "Tunisia"],
  ["TR", "Turkey"],
  ["TM", "Turkmenistan"],
  ["TC", "Turks and Caicos Islands"],
  ["TV", "Tuvalu"],
  ["UG", "Uganda"],
  ["UA", "Ukraine"],
  ["AE", "United Arab Emirates"],
  ["UM", "United States Minor Outlying Islands"],
  ["UY", "Uruguay"],
  ["UZ", "Uzbekistan"],
  ["VU", "Vanuatu"],
  ["VE", "Venezuela"],
  ["VN", "Viet Nam"],
  ["VG", "Virgin Islands, British"],
  ["VI", "Virgin Islands, U.S."],
  ["WF", "Wallis and Futuna"],
  ["EH", "Western Sahara"],
  ["YE", "Yemen"],
  ["ZM", "Zambia"],
  ["ZW", "Zimbabwe"],
];

defineProps<{
  lang?: string
  readonly?: boolean
}>()

const field = inject<string>("field")
</script>
